import { useQuery } from "@tanstack/react-query";

import { createAccountsLinkableToTidQueryOptions } from "@/api/graphql/billing/getAccountsLinkableToTid/queryOptions";

import type { UseAccountsLinkableToTidParams } from "./types";

export const useAccountsLinkableToTid = ({
  getAccountsLinkableToTidFn,
  query,
  targetAccountId,
  minQueryLength = 3,
}: UseAccountsLinkableToTidParams) => {
  const enabled = query.length >= minQueryLength;

  return useQuery(
    createAccountsLinkableToTidQueryOptions({
      getAccountsLinkableToTidFn,
      query,
      targetAccountId,
      enabled,
    }),
  );
};
